// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-friendly styles for Home2 component */

.sectorheatmap-container {
  width: 100%;
  height: inherit;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: auto;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  container-type: inline-size;
}

.sectorheatmap-container > .sectorheatmapboxtitletext {
  /*cursor: pointer;*/
  padding: 6px 2px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  color: #000000;
}

.sectorheatmap-container > .sectorheatmapboxtitletext > div:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}

.sectorheatmap-wrapper {
  display: flex;
  flex: 1;
  /*position: relative;*/
}

.color-pickers-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.menu-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-button {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-button:hover {
  background: #f8f9fa;
  border-color: #007bff;
}

.reset-button {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.reset-button:hover {
  background: #c82333;
  border-color: #c82333;
}

.sectorheatmap-chart-wrapper {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  border: 0px;
  box-shadow: none;
  overflow: hidden;
  /*transition: margin-left 0.3s ease;*/
}

.sectorheatmap-color-range-footer-container {
  width: 70px;
  padding-left: 10px;
  padding-top: 1px;
}

.sectorheatmap-color-range-footer {
  display: flex;
  flex-direction: column;
  /*width: 100%;*/
}

.sectorheatmap-color-range-footer-item-container {
  width: 100%;
  display: flex;
  margin-bottom: 1px;
}

.sectorheatmap-color-range-footer-item-color {
  min-width: 20px;
  margin-right: 5px;
}

.sectorheatmap-color-range-footer-item-text {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: normal;
  color: #3c3c4380;
}

.sectorheatmap-color-range-horizontal-footer-container {
  width: 100%;
  height: 50px;
  display: none;
}

.sectorheatmap-color-range-horizontal-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-self: flex-end;
}

.sectorheatmap-color-range-horizontal-footer-item-container {
  width: 100%;
  margin-top: 5px;
}

.sectorheatmap-color-range-horizontal-footer-item-color {
  min-height: 8px;
  min-width: 33px;
  margin-right: 2px;
}

.sectorheatmap-color-range-horizontal-footer-item-text {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: normal;
  color: #3c3c4380;
}

.sectorheatmap-tooltip-metric {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-size: 11px;
  text-align: right;
}

.sectorheatmap-tooltip-metric-label {
  display: inline-block;
  white-space: nowrap;
  width: 60px;
  text-align: left;
  font-weight: 400;
  color: var(--text-secondary);
}

.sectorheatmap-tooltip-metric-label-right {
  width: 100%;
  text-align: right;
  color: var(--text-primary);
}

.sectorheatmap-tooltip-ticker {
  font-size: 14px;
  line-height: 1.5;
  font-weight: bold;
  color: var(--text-primary);
}

.sectorheatmap-tooltip-performance {
  white-space: normal;
  min-width: 170px;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  flex-direction: column;
}

.sectorheatmap-tooltip-separator {
  height: 8px;
  border-top: 1px dotted var(--border-primary);
}

.positive {
  color: var(--text-up-color);
}

.negative {
  color: var(--text-down-color);
}

/* Mobile styles */
@container (max-width: 767px) {
  .menu-wrapper {
    width: 280px;
  }

  .sectorheatmap-chart-wrapper {
    margin-left: 0;
  }

  .menu-wrapper.collapsed {
    transform: translateX(-100%);
  }

  .color-pickers-grid {
    grid-template-columns: 1fr;
  }

  .menu-content {
    padding: 10px;
  }

  .menu-header {
    padding: 10px;
  }
}

/* Small mobile styles */
@container (max-width: 480px) {
  .menu-wrapper {
    width: 100%;
  }

  .menu-wrapper.collapsed {
    transform: translateX(-100%);
  }

  .color-pickers-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .menu-button {
    height: 45px;
    font-size: 16px;
  }

  .menu-toggle {
    height: 45px;
    font-size: 18px;
  }
}

/* Touch-friendly improvements */
@container (hover: none) and (pointer: coarse) {
  .menu-button {
    min-height: 44px;
    padding: 12px;
  }

  .menu-toggle {
    min-height: 44px;
    padding: 12px;
  }

  .color-pickers-grid {
    gap: 12px;
  }
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}

/* Back button */
.back-button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 12px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 28px;
}

.back-button:hover {
  background: #0056b3;
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
  transform: translateY(-2px);
}

/* Floating menu button */
.floating-menu-button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 12px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 28px;
}

.floating-menu-button:hover {
  background: #0056b3;
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
  transform: translateY(-2px);
}

.floating-menu-button.hidden {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
}

.floating-menu-button.visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

/* Landscape orientation */
@container (max-width: 767px) and (orientation: landscape) {
  .menu-wrapper {
    width: 250px;
  }

  .menu-content {
    padding: 8px;
  }

  .color-pickers-grid {
    gap: 6px;
  }

  .floating-menu-button {
    top: 10px;
    left: 10px;
    padding: 8px 16px;
    font-size: 14px;
  }
}

@container (max-width: 767px) {
  .sectorheatmap-color-range-footer-container {
    display: none;
  }

  .sectorheatmap-color-range-horizontal-footer-container {
    display: block;
  }
}

@container (max-width: 460px) {
  .sectorheatmap-color-range-horizontal-footer-item-color {
    min-width: 26px;
  }

  .sectorheatmap-color-range-horizontal-footer-item-text {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/SectorHeatmapWidget/SectorHeatmapWidget.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Mobile-friendly styles for Home2 component */\n\n.sectorheatmap-container {\n  width: 100%;\n  height: inherit;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  cursor: auto;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  container-type: inline-size;\n}\n\n.sectorheatmap-container > .sectorheatmapboxtitletext {\n  /*cursor: pointer;*/\n  padding: 6px 2px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 20px;\n  color: #000000;\n}\n\n.sectorheatmap-container > .sectorheatmapboxtitletext > div:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 5px;\n}\n\n.sectorheatmap-wrapper {\n  display: flex;\n  flex: 1;\n  /*position: relative;*/\n}\n\n.color-pickers-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.menu-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.menu-button {\n  width: 100%;\n  height: 40px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.menu-button:hover {\n  background: #f8f9fa;\n  border-color: #007bff;\n}\n\n.reset-button {\n  background: #dc3545;\n  color: white;\n  border-color: #dc3545;\n}\n\n.reset-button:hover {\n  background: #c82333;\n  border-color: #c82333;\n}\n\n.sectorheatmap-chart-wrapper {\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  height: 100%;\n  border: 0px;\n  box-shadow: none;\n  overflow: hidden;\n  /*transition: margin-left 0.3s ease;*/\n}\n\n.sectorheatmap-color-range-footer-container {\n  width: 70px;\n  padding-left: 10px;\n  padding-top: 1px;\n}\n\n.sectorheatmap-color-range-footer {\n  display: flex;\n  flex-direction: column;\n  /*width: 100%;*/\n}\n\n.sectorheatmap-color-range-footer-item-container {\n  width: 100%;\n  display: flex;\n  margin-bottom: 1px;\n}\n\n.sectorheatmap-color-range-footer-item-color {\n  min-width: 20px;\n  margin-right: 5px;\n}\n\n.sectorheatmap-color-range-footer-item-text {\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: normal;\n  color: #3c3c4380;\n}\n\n.sectorheatmap-color-range-horizontal-footer-container {\n  width: 100%;\n  height: 50px;\n  display: none;\n}\n\n.sectorheatmap-color-range-horizontal-footer {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-self: flex-end;\n}\n\n.sectorheatmap-color-range-horizontal-footer-item-container {\n  width: 100%;\n  margin-top: 5px;\n}\n\n.sectorheatmap-color-range-horizontal-footer-item-color {\n  min-height: 8px;\n  min-width: 33px;\n  margin-right: 2px;\n}\n\n.sectorheatmap-color-range-horizontal-footer-item-text {\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: normal;\n  color: #3c3c4380;\n}\n\n.sectorheatmap-tooltip-metric {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  font-size: 11px;\n  text-align: right;\n}\n\n.sectorheatmap-tooltip-metric-label {\n  display: inline-block;\n  white-space: nowrap;\n  width: 60px;\n  text-align: left;\n  font-weight: 400;\n  color: var(--text-secondary);\n}\n\n.sectorheatmap-tooltip-metric-label-right {\n  width: 100%;\n  text-align: right;\n  color: var(--text-primary);\n}\n\n.sectorheatmap-tooltip-ticker {\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: bold;\n  color: var(--text-primary);\n}\n\n.sectorheatmap-tooltip-performance {\n  white-space: normal;\n  min-width: 170px;\n  font-size: 12px;\n  font-weight: normal;\n  display: flex;\n  flex-direction: column;\n}\n\n.sectorheatmap-tooltip-separator {\n  height: 8px;\n  border-top: 1px dotted var(--border-primary);\n}\n\n.positive {\n  color: var(--text-up-color);\n}\n\n.negative {\n  color: var(--text-down-color);\n}\n\n/* Mobile styles */\n@container (max-width: 767px) {\n  .menu-wrapper {\n    width: 280px;\n  }\n\n  .sectorheatmap-chart-wrapper {\n    margin-left: 0;\n  }\n\n  .menu-wrapper.collapsed {\n    transform: translateX(-100%);\n  }\n\n  .color-pickers-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .menu-content {\n    padding: 10px;\n  }\n\n  .menu-header {\n    padding: 10px;\n  }\n}\n\n/* Small mobile styles */\n@container (max-width: 480px) {\n  .menu-wrapper {\n    width: 100%;\n  }\n\n  .menu-wrapper.collapsed {\n    transform: translateX(-100%);\n  }\n\n  .color-pickers-grid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .menu-button {\n    height: 45px;\n    font-size: 16px;\n  }\n\n  .menu-toggle {\n    height: 45px;\n    font-size: 18px;\n  }\n}\n\n/* Touch-friendly improvements */\n@container (hover: none) and (pointer: coarse) {\n  .menu-button {\n    min-height: 44px;\n    padding: 12px;\n  }\n\n  .menu-toggle {\n    min-height: 44px;\n    padding: 12px;\n  }\n\n  .color-pickers-grid {\n    gap: 12px;\n  }\n}\n\n.menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n}\n\n/* Back button */\n.back-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 12px 12px;\n  font-size: 16px;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  min-height: 28px;\n}\n\n.back-button:hover {\n  background: #0056b3;\n  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);\n  transform: translateY(-2px);\n}\n\n/* Floating menu button */\n.floating-menu-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 12px 12px;\n  font-size: 16px;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  min-height: 28px;\n}\n\n.floating-menu-button:hover {\n  background: #0056b3;\n  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);\n  transform: translateY(-2px);\n}\n\n.floating-menu-button.hidden {\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-10px);\n}\n\n.floating-menu-button.visible {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n/* Landscape orientation */\n@container (max-width: 767px) and (orientation: landscape) {\n  .menu-wrapper {\n    width: 250px;\n  }\n\n  .menu-content {\n    padding: 8px;\n  }\n\n  .color-pickers-grid {\n    gap: 6px;\n  }\n\n  .floating-menu-button {\n    top: 10px;\n    left: 10px;\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n\n@container (max-width: 767px) {\n  .sectorheatmap-color-range-footer-container {\n    display: none;\n  }\n\n  .sectorheatmap-color-range-horizontal-footer-container {\n    display: block;\n  }\n}\n\n@container (max-width: 460px) {\n  .sectorheatmap-color-range-horizontal-footer-item-color {\n    min-width: 26px;\n  }\n\n  .sectorheatmap-color-range-horizontal-footer-item-text {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
